import React from "react";
import ProvidePayrollInputTable from "../../containers/ProvidePayrollInputTable/ProvidePayrollInputTable";

const ProvidePayrollInput = () => {
  return (
    <>
      <ProvidePayrollInputTable />
    </>
  );
};
export default ProvidePayrollInput;
